module.exports = __webpack_public_path__ + "static/media/mouse-alt.cad691a3.svg";